module.exports = __webpack_public_path__ + "img/avviso-white.6de2c6c4.svg";